import { createAsyncThunk } from "@reduxjs/toolkit";

import { IQueryParams, searchStores } from "../../../api/retail";
import { ILocation, IRetailStoreWithDistance } from "../../../models/location";
import { isLatLngLocation, isZipLocation } from "../../../utils/guards";

interface LoadClosestStoresArgs {
    location: ILocation;
    extraFilters?: Partial<IQueryParams>;
    loadKey?: string;
}

interface LoadClosestStoresResult {
    stores: ReadonlyArray<IRetailStoreWithDistance>;
    loadKey?: string;
}

const buildBaseQuery = (location: ILocation): IQueryParams | null => {
    if (isLatLngLocation(location)) {
        return {
            origLat: location.lat,
            origLng: location.lng,
        };
    }
    if (isZipLocation(location)) {
        return {
            q: location.zip,
        };
    }
    return null;
};

export const loadClosestStores = createAsyncThunk(
    "retail/loadClosestStores",
    async (args: LoadClosestStoresArgs): Promise<LoadClosestStoresResult> => {
        const baseQuery = buildBaseQuery(args.location);
        if (!baseQuery) {
            return { stores: [], loadKey: args.loadKey };
        }
        const stores = await searchStores({
            ...baseQuery,
            ...args.extraFilters,
        });
        return { stores, loadKey: args.loadKey };
    },
);
